import React from "react";
import OthersContent from "./OthersContent";

function Others() {
  return (
    <>
        <OthersContent title="ご案内">
            <p>
            ・<span className="underline">2026年11月から免税での配送が可能になります。</span>
            <br />
            ・本サービスは日本人が海外へ配送する時にもご利用いただけます。
            <br />
            ・食品、相手国または配送会社の決まりにより送れないものは本サービスの対象外となります。
            <br />
            <span className="pl-5">禁制品例（全世界共通）：スプレー缶・貴重品（紙幣や宝石等）・モバイルバッテリー等</span>
            </p>
        </OthersContent>

        <OthersContent title="システム費用について">
            <p>
            導入費用　：0円　/　月額利用料：0円
            </p>
        </OthersContent>
    </>

  );
}

export default Others;